import { getQueryClient } from "@/services/get-query-client";
import { authenticatedFetch } from "@/services/utils/authenticatedFetch";

export default async function fetchSettings<T>(): Promise<T> {
  const queryClient = getQueryClient();
  return await queryClient.fetchQuery({
    queryKey: ["settings"],
    queryFn: async () => {
      const response = await authenticatedFetch("/api/settings");
      if (!response.ok) {
        throw new Error(`Failed to fetch settings: ${response.status}`);
      }
      return response.json();
    },
  });
}
